import { atom } from 'jotai'
import type { TaiwanCreateAccountForm, TaiwanShippingForm, TaiwanHostedGatewayData, TaiwanDuplicateOrderResponse } from '../types/taiwan.types'

export const initialTaiwanAccountForm: TaiwanCreateAccountForm = {
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    password: '',
    address1: '',
    city: '',
    zip_code: ''
}

export const initialTaiwanShippingForm: TaiwanShippingForm = {
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    address1: '',
    city: '',
    zip_code: ''
}

/**
 * Structured ship-to captured at submit time so the payment step can render a
 * clean address. The format's `ship_to.address` is a single jammed string
 * (zip+city+address1, no separators); this keeps the parts for formatting.
 * Null on a fresh payment-page load (hard refresh) → fall back to the format.
 */
export interface TaiwanShipToInfo {
    name: string
    address1: string
    city: string
    zip: string
    email: string
    phone: string
}
export const taiwanShipToAtom = atom<TaiwanShipToInfo | null>(null)

/** Raw order format returned for the active UUID (summary / pricing source). */
export const taiwanFormatDataAtom = atom<Record<string, unknown> | null>(null)

/** True while a cart edit is re-syncing the server session (PUT + format
 *  refetch). Drives the order-summary skeleton during the slow recalculation. */
export const taiwanCartSyncingAtom = atom<boolean>(false)
export const taiwanCheckoutLoadingAtom = atom<boolean>(false)
export const taiwanCheckoutErrorsAtom = atom<string[]>([])

// ─── Payment step (hosted / redirect gateway) ────────────────────────────────
/** True while preparing the hosted-gateway payment (Proceed-to-Payment click). */
export const taiwanPaymentLoadingAtom = atom<boolean>(false)
export const taiwanPaymentErrorsAtom = atom<string[]>([])
/**
 * Gateway payload to auto-submit as a hidden redirect form. Set once the payment
 * router returns a form-post (non-`relocation`) response; null otherwise.
 */
export const taiwanRedirectFormAtom = atom<TaiwanHostedGatewayData | null>(null)
/** Populated when the duplicate-order guard trips, drives the confirm dialog. */
export const taiwanDuplicateOrderAtom = atom<TaiwanDuplicateOrderResponse | null>(null)

/** Selected payment method on the payment step. Credit card → 2c2p hosted
 *  redirect; Cash on Delivery → the router settles the order directly (see
 *  useTaiwanPayment.submitHostedPayment). */
export type TaiwanPaymentMethod = 'creditcard' | 'cashOnDelivery'
export const taiwanPaymentMethodAtom = atom<TaiwanPaymentMethod>('creditcard')
